<script setup lang="ts">
  import { useScriptTag } from '@vueuse/core'
  import { computed, onMounted } from 'vue'
  import ErrorToasts from '~renderer/components/ErrorToasts.vue'
  import UsernameResetModal from '~renderer/components/UsernameResetModal.vue'
  import { useAuth } from '~renderer/composables/useAuth'
  import { useState } from '~renderer/composables/useState'
  import { isAuthenticatedUser } from '~shared/util/user'

  const { user, isBanned } = useAuth()
  const { gdpr, usp, adsEnabled } = useState()
  const showResetModal = computed(
    () => user.value && isAuthenticatedUser(user.value) && user.value.usernameResetRequired,
  )
  const { load } = useScriptTag('https://s.nitropay.com/ads-434.js', undefined, {
    immediate: false,
    manual: true,
  })

  onMounted(async () => {
    if (isBanned.value && !window.location.href.endsWith('/auth/banned')) {
      window.location.href = '/auth/banned'
      return
    }
    if (!adsEnabled.value) return
    await load()

    document.addEventListener(
      'nitroAds.loaded',
      async () => {
        gdpr.value = !!window.__cmp || !!window.location.search.match(/gdpr_debug=1/)
        usp.value = !!window.__uspapi || !!window.location.search.match(/usp_debug=1/)
      },
      { once: true },
    )
  })
</script>

<template>
  <slot />
  <UsernameResetModal v-if="showResetModal" />
  <ErrorToasts />
</template>
